import { http } from "services/http";

import type {
  DepositAddRequest,
  DepositCostRequest,
  DepositCostResponse,
  DepositFormOptions,
  DepositIdRequest,
  DepositInfoResponse,
  DepositsListRequest,
  DepositsListResponse,
  DepositUpdateRequest,
} from "models/deposits.model";
import type { UserSelectOption, UsersSelectRequest } from "models/users.model";

export const depositsApi = {
  getDepositsData: (data?: DepositsListRequest) =>
    http.quiet().post<DepositsListResponse>("/api/deposits", data ? { ...data } : null),
  getUsersOpt: (data: UsersSelectRequest) =>
    http.quiet().post<UserSelectOption[]>("/api/get-users", { ...data }),
  getDataToAddDeposit: () => http.quiet().get<DepositFormOptions>("/api/deposit/add"),
  addDeposit: (data: DepositAddRequest) => http.quiet().post("/api/deposit/add", { ...data }),
  getCost: (data: DepositCostRequest) => http.quiet().post<DepositCostResponse>("/api/get-cost", { ...data }),
  getDepositInfo: (id: number | string) =>
    http.quiet().get<DepositInfoResponse>(`/api/deposit/${encodeURIComponent(id)}`),
  closeDeposit: (data: DepositIdRequest) => http.quiet().post("/api/deposit/close", { ...data }),
  cancelDeposit: (data: DepositIdRequest) => http.quiet().post("/api/deposit/cancel", { ...data }),
  updateDeposit: (data: DepositUpdateRequest) =>
    http.quiet().post("/api/deposit/update", { ...data }),
};
